try {
  (function() {
    let timer = null

    timer = setInterval(function() {
      const STATIC_ELM_APP_EMBED = "#app-embed"
      const STATIC_ELM_ADDR_LABEL = "#label-billing_address_recipient"

      const targetNode = document.querySelectorAll(STATIC_ELM_APP_EMBED)

      if (!targetNode.length) {
        return
      }

      clearInterval(timer)

      let form = targetNode[0]

      if (!form.shadowRoot) {
        return
      }

      form = form.shadowRoot

      const addr = form.querySelector(STATIC_ELM_ADDR_LABEL)

      if (!addr) {
        return
      }

      addr.innerText = 'Company Name'

      const btn = form.querySelector('button[type="submit"]')

      if (!btn) {
        return
      }

      const country = form.querySelector('._selectToggleText_1ujcz_25').innerText

      const STATIC_NOT_ALLOWED_COUNTRIES = [
        'Australia',
        'Bahrain',
        'Canada',
        'Colombia',
        'Cook Islands',
        'Ecuador',
        'Fiji',
        'French Polynesia',
        'Germany',
        'Guam',
        'India',
        'Islands of Palau',
        'Kiribati',
        'Kuwait',
        'Marshall Islands ',
        'Mexico',
        'Micronesia',
        'Mongolia ',
        'Nauru',
        'New Zealand',
        'Oman',
        'Philippines',
        'Qatar ',
        'Samoa',
        'Saudi Arabia',
        'South Africa',
        'South Korea ',
        'Tonga',
        'Trinidad & Tobago',
        'Tuvalu;',
        'United Arab Emirates',
        'United Kingdom',
        'United States'
      ]

      btn.addEventListener('click', function(e) {
        if (!STATIC_NOT_ALLOWED_COUNTRIES.includes(country)) {
          e.preventDefault()
          alert('We currently do not have any product offerrings for your selected country. Please reach out to distribution@goli.com for more information.')
        }
      })
    }, 1000)
  }())
} catch (e) {

}
